import React, { useState, useRef, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlay, faPause } from "@fortawesome/free-solid-svg-icons";
import "./App.css"; // Ensure this contains updated styles

const EpisodePage = () => {
    const location = useLocation();
    const episode = location.state?.episode;

    const [isPlaying, setIsPlaying] = useState(false);
    const [progress, setProgress] = useState(0);
    const [currentTime, setCurrentTime] = useState(0);
    const [duration, setDuration] = useState(0);
    const audioRef = useRef(null);

    useEffect(() => {
        if (!episode) {
            console.error("No episode data found");
        }
    }, [episode]);

    if (!episode) {
        return <div className="container">Episode not found.</div>;
    }

    const togglePlay = () => {
        if (!audioRef.current) return;
        if (isPlaying) {
            audioRef.current.pause();
        } else {
            audioRef.current.play();
        }
        setIsPlaying(!isPlaying);
    };

    const handleTimeUpdate = () => {
        const audio = audioRef.current;
        if (audio) {
            const progressPercent = (audio.currentTime / audio.duration) * 100;
            setProgress(progressPercent);
            setCurrentTime(audio.currentTime);
        }
    };

    const handleLoadedMetadata = () => {
        if (audioRef.current) {
            setDuration(audioRef.current.duration);
        }
    };

    const handleProgressClick = (e) => {
        const audio = audioRef.current;
        if (!audio) return;
        const bar = e.currentTarget;
        const clickPosition = e.nativeEvent.offsetX;
        const barWidth = bar.clientWidth;
        const newTime = (clickPosition / barWidth) * audio.duration;
        audio.currentTime = newTime;
    };

    const formatTime = (time) => {
        const minutes = Math.floor(time / 60);
        const seconds = Math.floor(time % 60);
        return `${minutes}:${seconds < 10 ? "0" : ""}${seconds}`;
    };

    return (
        <div className="App">
            {/* Navigation Bar */}
            <header>
                <div className="container header-container">
                    <div className="logo"></div>
                    <nav>
                        <ul>
                            <li>
                                <a href="/">Home</a>
                            </li>
                            <li>
                                <a href="/episodes">Episodes</a>
                            </li>
                        </ul>
                    </nav>
                </div>
            </header>

            {/* Episode Content */}
            <section className="episode-container">
                <div className="container">
                    <div className="episode-content">
                        {/* Left Side - 75% Width */}
                        <div className="episode-details">
                            <img src={episode.image} alt={episode.title} />
                            <br />
                            <span className="episode-number">
                                EPISODE {episode.id}
                            </span>
                            <span className="episode-date">
                                {episode.pubDate}
                            </span>
                            <h1>{episode.title}</h1>
                            <p>{episode.description}</p>

                            {/* Styled Audio Player */}
                            <div className="audio-player">
                                <button
                                    className="play-button"
                                    onClick={togglePlay}
                                >
                                    <FontAwesomeIcon
                                        icon={isPlaying ? faPause : faPlay}
                                    />
                                </button>
                                <div
                                    className="progress-bar"
                                    onClick={handleProgressClick}
                                >
                                    <div
                                        className="progress"
                                        style={{ width: `${progress}%` }}
                                    ></div>
                                </div>
                            </div>
                            <div className="audio-time">
                                <small>
                                    {formatTime(currentTime)} /{" "}
                                    {formatTime(duration)}
                                </small>
                            </div>
                            <audio
                                ref={audioRef}
                                src={episode.audio}
                                onTimeUpdate={handleTimeUpdate}
                                onLoadedMetadata={handleLoadedMetadata}
                            />
                        </div>

                        {/* Right Side - 25% Width */}
                        <div className="episode-sidebar">
                            <div className="extra-content">
                                <h3>More Episodes</h3>
                                <p>Check out our latest episodes!</p>
                                <a href="/episodes" className="btn">
                                    All Episodes →
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default EpisodePage;
